var map = {
	"./channel_a/Bidding-Agency@2x.jpg": 8563,
	"./channel_a/ad 2.png": 967,
	"./channel_a/ad.png": 997,
	"./channel_a/banner.jpg": 4764,
	"./channel_a/bidder@2x.jpg": 6856,
	"./channel_a/expert@2x.jpg": 2010,
	"./channel_a/logo.png": 7947,
	"./channel_a/role_bg@2x.jpg": 4554,
	"./channel_a/tenderer@2x.jpg": 7,
	"./channel_b/Bidding Agency@2x.png": 5187,
	"./channel_b/adLogo.png": 7997,
	"./channel_b/adLogo1.png": 3968,
	"./channel_b/banner.png": 4065,
	"./channel_b/expert@2x.png": 1237,
	"./channel_b/logo.png": 9422,
	"./channel_b/logo2.png": 3262,
	"./channel_b/role_bg@2x.png": 4299,
	"./channel_b/tenderer@2x.png": 748,
	"./new_slices/Bidding Agency@2x.png": 1683,
	"./new_slices/Notice.png": 751,
	"./new_slices/banner.png": 9009,
	"./new_slices/banner_改版.png": 805,
	"./new_slices/bidder@2x.png": 2547,
	"./new_slices/customer service.png": 4290,
	"./new_slices/expand.png": 5059,
	"./new_slices/expert@2x.png": 7957,
	"./new_slices/home@2x.png": 9390,
	"./new_slices/lgin_bg@2x.jpg": 221,
	"./new_slices/lgin_picture@2x.jpg": 4346,
	"./new_slices/logo.png": 6110,
	"./new_slices/logo2(1).png": 3174,
	"./new_slices/logo2(2).png": 8855,
	"./new_slices/logo2.png": 4158,
	"./new_slices/logo2@2x.png": 6358,
	"./new_slices/logo3.png": 7303,
	"./new_slices/more.png": 3432,
	"./new_slices/positioning.png": 3228,
	"./new_slices/role_bg@2x.png": 6539,
	"./new_slices/search.png": 2279,
	"./new_slices/telephone.png": 1439,
	"./new_slices/tenderer@2x.png": 4156,
	"./new_slices/weixin.jpg": 6957,
	"./new_slices/zhuanjia.jpg": 5021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3747;